import {useCallback, useMemo} from 'react';

import {observer} from 'mobx-react-lite';

import type {GetComponentProps} from '../../../../utils/utility-types';
import type {Props} from './types';

import {Clickable} from '../../../../uikit/Clickable';
import {AccountsListItemJSX} from '../../components/AccountsListItem';
import {AccountModel} from './model';

export const AccountsListItem = observer<Props>(
  ({account, onClick, onDeleteIconClick, ...rest}) => {
    const model = useMemo(() => new AccountModel(account), [account]);

    const onClickCb = useCallback(() => {
      onClick?.(account);
    }, [account, onClick]);

    const onDeleteIconClickCb: GetComponentProps<
      typeof AccountsListItemJSX
    >['onDeleteIconClick'] = useCallback(
      e => {
        e.event.DOMEvent?.stopPropagation?.();

        onDeleteIconClick?.(e, account);
      },
      [account, onDeleteIconClick],
    );

    return (
      <Clickable onClick={onClickCb}>
        <AccountsListItemJSX
          isPrimary={model.isPrimary}
          onDeleteIconClick={
            onDeleteIconClick ? onDeleteIconClickCb : undefined
          }
          type={model.type}
          value={model.value}
          {...rest}
        />
      </Clickable>
    );
  },
);
